var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1349_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1350_",
    x: 200,
    y: 390,
    style: {
      fill: "#A78966"
    },
    width: 60,
    height: 50
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1357_",
    style: {
      fill: "#3FA45A"
    },
    d: "M230,20c-28.325,0-53.193,14.734-67.409,36.943C152.634,52.494,141.611,50,130,50 c-44.183,0-80,35.817-80,80c0,7.223,0.974,14.216,2.768,20.872C21.346,167.863,0,201.104,0,239.333 c0,37.875,20.955,70.851,51.9,87.982C59.815,363.17,91.765,390,130,390h100V20z M110,310c-11.046,0-20-8.954-20-20 c0-11.046,8.954-20,20-20s20,8.954,20,20C130,301.046,121.046,310,110,310z M170,350c-11.046,0-20-8.954-20-20 c0-11.046,8.954-20,20-20s20,8.954,20,20C190,341.046,181.046,350,170,350z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1366_",
    style: {
      fill: "#317F46"
    },
    d: "M407.034,151.569C408.952,144.705,410,137.477,410,130c0-44.183-35.817-80-80-80 c-11.611,0-22.634,2.494-32.591,6.943C283.193,34.734,258.325,20,230,20v370h100c38.15,0,70.041-26.712,78.045-62.448 C439.009,310.557,460,277.648,460,239.833C460,201.609,438.55,168.399,407.034,151.569z M330,270c-11.046,0-20-8.954-20-20 c0-11.046,8.954-20,20-20s20,8.954,20,20C350,261.046,341.046,270,330,270z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1371_",
    style: {
      fill: "#317F46"
    },
    cx: 170,
    cy: 330,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1374_",
    style: {
      fill: "#3FA45A"
    },
    cx: 330,
    cy: 250,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1377_",
    style: {
      fill: "#317F46"
    },
    cx: 110,
    cy: 290,
    r: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOak);
export default __webpack_public_path__ + "static/media/oak.b3a77577bd215db32263d1a6d82b6de3.svg";
export { ForwardRef as ReactComponent };